export const TEXT = {
    TITLE_NAME: 'Reset Password',
    TITLE_DESCRIPTION: 'Verify your email address',
    EMAIL_ADDRESS: 'Email Address',
    VERIFICATION_CODE: 'Verification Code',
    VERIFY_EMAIL: 'Verify Email',
    BACK_TO_LOGIN: 'Back to Login',
    RESET_PASSWORD: 'Reset Password'
}